export default __webpack_public_path__ + "static/media/anhbia.af9709a3.jpg";